import { configuration } from '../lib/configuration'
import { GOOGLE_API } from './constants'
//
// export const environment = 'prod'
// export const environment = 'local_prod'

// export const environment =  'local_dev'
export const environment = 'dev_phase3'

// const environment = 'local_prod' 
// export const environment = 'dev'
// const environment = 'demo'
export const backendUrl = configuration[environment].url

export const authUrl = `${backendUrl}/auth`
export const companyAdminUrl = `${backendUrl}/CAallEmployee`
// export const allEmployeeUrl = `${backendUrl}/detail`
export const superAdminCompanyAdminUrl = `${backendUrl}/SAcompanyAdmin`     
export const featuresUrl = `${backendUrl}/Features`
export const locationUrl = `${backendUrl}/Location`
export const targetUrl =   `${featuresUrl}/Target`
export const masterUrl = `${backendUrl}/Master`
export const tmpOrderUrl = `${backendUrl}/tmpOrder`
export const beatPlanUrl = `${backendUrl}/beat/plan`

const dashBoardUrl = `${backendUrl}/DashBoard`
const superAdminUrl = `${backendUrl}/SuperAdmin`
const learningUrl = `${backendUrl}/Learning`
const auditUrl = `${backendUrl}/Audit`
const taskMasterUrl = `${backendUrl}/TaskMaster`


export const API = {
  //AUTHENTICATION
  LOGIN: `${authUrl}/login`,
  UPDATE_PASSWORD_EMPLOYEE: `${authUrl}/updatePasswordFromApp`,
  SIGNUP: `${authUrl}/registerCompanyAdmin`,
  SEND_OTP_MOBILE: `${authUrl}/sendOtp`,
  VERIFY_OTP_MOBILE: `${authUrl}/verifyOtp`,
  SEND_OTP_EMAIL: `${authUrl}/sendOtpOnEmail`,
  VERIFY_OTP_EMAIL: `${authUrl}/verifyOtpOnEmail`,
  UPDATE_PASSWORD: `${authUrl}/updatePassword`,
  RESET_PASSWORD: `${authUrl}/resetPassword`,
  GET_LOGGED_IN_USER: `${authUrl}/getLoggedInUser`,
  ACCEPT_POLICY: `${authUrl}/acceptPolicy`,
  UPLOAD_FILE: `${authUrl}/uploadFileToAws`,
  GET_CSV_PDF_DATA: (searchParams) => `${dashBoardUrl}/pdfCsvData${searchParams}`,

  // SUPERADMIN
  GET_ALL_SUPERADMINS: (searchParams) => `${superAdminUrl}/getAllSuperAdmins${searchParams}`,
  GET_ALL_REWARD: (searchParams) => `${backendUrl}/Reward/getRewardDataWithDownload${searchParams}`,
  ADD_SUPERADMIN: `${superAdminUrl}/addSuperAdmin`,
  ADD_WEIGHTAGE: `${backendUrl}/Reward/addModuleWeightage`,
  EDIT_SUPERADMIN: `${superAdminUrl}/editSuperAdmin`,
  DELETE_MANY_SUPERADMIN: `${superAdminUrl}/deleteManySuperAdmin`,
  GET_SUPERADMIN: (superAdminId) => `${superAdminUrl}/getSuperAdmin${superAdminId}`,

  // SUPER ADMIN SUBSCRIPTIONS:
  GET_ALL_SUBSCRIPTIONS: (searchParams) => `${backendUrl}/subscription/${searchParams}`,
  ADD_SUBSCRIPTION: `${backendUrl}/subscription`,
  CREATE_ORDER: `${backendUrl}/subscription/create-order`,
  PURCHASE_SUBSCRIPTION: `${backendUrl}/subscription/purchase`,
  EDIT_SUBSCRIPTION: (Id) => `${backendUrl}/subscription/${Id}`,
  ABOUT_TO_EXPIRE_PLANS: (Id) =>  `${backendUrl}/subscription/aboutToExpirePlans`,
  GET_SUBSCRIPTION: (SearchParams)=> `${backendUrl}/subscription/${SearchParams}`,
  DELETE_SUBSCRIPTION: (SearchParams)=> `${backendUrl}/subscription/${SearchParams}`,
  ACTIVE_SUBSCRIPTIONS: (searchParams) => `${backendUrl}/subscription/get/activeSubscriptions/${searchParams}`,
  ACTIVE_SUBSCRIPTION_WITH_PURCHASES: (searchParams) => `${backendUrl}/subscription/get/subscriptionWithPurchases/${searchParams}`,

  // LEARNING
  GET_ALL_TRAININGCATEGORY: (searchParams) => `${learningUrl}/getAllTrainingCategory/${searchParams}`,
  GET_TRAININGCATEGORY: (id) => `${learningUrl}/getTrainingCategory?trainingCategoryId=${id}`,
  ADD_TRAININGCATEGORY: `${learningUrl}/addTrainingCategory`,
  EDIT_TRAININGCATEGORY: ()=>`${learningUrl}/editTrainingCategory`,
  DELETE_MANY_TRAININGCATEGORY: `${learningUrl}/deleteManyTrainingCategory`,

  GET_ALL_TRAININGCATEGORYCONTENT: (searchParams) => `${learningUrl}/getAllTrainingCategoryContent/${searchParams}`,
  GET_TRAININGCATEGORYCONTENT: (searchParams) => `${learningUrl}/getTrainingCategoryContent/?trainingCategoryContentId=${searchParams}`,
  ADD_TRAININGCATEGORYCONTENT: `${learningUrl}/addTrainingCategoryContent`,
  EDIT_TRAININGCATEGORYCONTENT: (searchParams) =>  `${learningUrl}/editTrainingCategoryContent`,
  DELETE_MANY_TRAININGCATEGORYCONTENT:   (searchParams)=> `${learningUrl}/deleteManyTrainingCategoryContent/${searchParams}`,

  // QUIZ
  GET_ALL_CONTENTQUESTION: (searchParams) => `${learningUrl}/getAllContentQuestion${searchParams}`,
  ADD_CONTENTQUESTION: `${learningUrl}/addContentQuestion`,
  EDIT_CONTENTQUESTION: `${learningUrl}/editContentQuestion`,
  DELETE_MANY_CONTENTQUESTION: `${learningUrl}/deleteManyContentQuestion`,

  // AUDIT
  GET_ALL_AUDITQUESTION: (searchParams) => `${auditUrl}/getAllAuditQuestions${searchParams}`,
  GET_ALL_AUDITSCORE: (searchParams) => `${auditUrl}/getAllAuditScore${searchParams}`,
  GET_ALL_AUDIT_TASK: (searchParams) => `${auditUrl}/getAllTasks${searchParams}`,
  EDIT_AUDIT_TASK: `${auditUrl}/actionOnTask`,
  CREATE_TASK: `${auditUrl}/createTask`,
  EDIT_POS_TASK: `${auditUrl}/editTask`,

  // TASK MASTER
  GET_ALL_TASK: (searchParams) => `${taskMasterUrl}/getAllTaskMaster${searchParams}`,
  ADD_TASK: `${taskMasterUrl}/addTaskMaster`,
  EDIT_TASK: `${taskMasterUrl}/editTaskMaster`,
  DELETE_MANY_TASK: `${taskMasterUrl}/deleteManyTaskMaster`,

  // SUPERADMIN----> COMPANY
  GET_ALL_COMPANIES: (searchParams) => `${superAdminUrl}/Company/getAllCompanies${searchParams}`,
  ADD_COMPANY: `${superAdminUrl}/Company/addCompany`,
  EDIT_COMPANY: ()=>`${superAdminUrl}/Company/editCompany`,
  DELETE_MANY_COMPANY: (searchParams) =>  `${superAdminUrl}/Company/deleteManyCompany${searchParams}`,
  GET_COMPANY: (companyId) => `${superAdminUrl}/Company/getCompany${companyId}`,

  // Upload Header
  GET_ALL_UPLOAD_HEADERS: (searchParams) => `${masterUrl}/UploadHeader/getAllUploadHeader${searchParams}`,
  ADD_UPLOAD_HEADER: `${masterUrl}/UploadHeader/addUploadHeader`,
  EDIT_UPLOAD_HEADER: `${masterUrl}/UploadHeader/editUploadHeader`,
  DELETE_MANY_UPLOAD_HEADER: `${masterUrl}/UploadHeader/deleteManyUploadHeader`,
  // GET_COMPANY: (companyId) => `${masterUrl}/UploadHeader/getUploadHeader?companyId=${companyId}`,

  //Features
  ADD_LOCATION: `${featuresUrl}/Location/addLocation`,
  EDIT_LOCATION: `${featuresUrl}/Location/editLocation`,
  APPROVE_LEAVE: `${featuresUrl}/Leave/ApproveLeave`,
  LINK_LOCATION: `${featuresUrl}/Location/linkLocation`,
  LINK_KYC: `${featuresUrl}/Kyc/linkKyc`,
  ADD_KYC: `${featuresUrl}/Kyc/addKYC`,
  EDIT_KYC: `${featuresUrl}/Kyc/editKYC`,

  //DASHBOARD
  GET_ATTENDANCE_DASHBOARD: (searchParams) => `${dashBoardUrl}/getAttendanceDashBoard${searchParams}`,
  GET_LEAD_DASHBOARD: (searchParams) => `${dashBoardUrl}/getLeadDashBoard${searchParams}`,
  GET_LEAVE_DASHBOARD: (searchParams) => `${dashBoardUrl}/getLeaveDashBoard${searchParams}`,
  GET_HOME_DASHBOARD: (searchParams) => `${dashBoardUrl}/getHomeDashBoard${searchParams}`,
  GET_SALES_DASHBOARD: (searchParams) => `${dashBoardUrl}/getSalesDashBoard${searchParams}`,
  GET_AUDIT_DASHBOARD: (searchParams) => `${dashBoardUrl}/getAuditDashboard${searchParams}`,

  // LEAVES
  GET_BELOW_EMPLOYEE_LEAVES: (searchParams) => `${featuresUrl}/Leave/getBelowEmployeeLeave${searchParams}`,
  GET_LEAVE_REPORT: (searchParams) => `${featuresUrl}/Leave/getLeaveReport${searchParams}`,
  DELETE_LEAVE: `${featuresUrl}/Leave/deleteLeave`,
  DELETE_MANY_LEAVE: `${featuresUrl}/Leave/deleteManyLeave`,
  GET_LEAVE_REQUEST: (leaveId) => `${featuresUrl}/Leave/getLeave?leaveId=${leaveId}`,
  EDIT_LEAVE_REQUEST: `${featuresUrl}/Leave/editLeave`,
  
  //ATTENDANCE
  ADD_ATTENDANCE_BY_ADMIN: `${featuresUrl}/Attendance/addAttendanceByAdmin`,
  GET_BELOW_EMPLOYEE_ATTENDANCE: (searchParams) => `${featuresUrl}/Attendance/getBelowEmployeeAttendance${searchParams}`,
  GET_FILTER_ATTENDANCE: (searchParams) => `${featuresUrl}/attendance/filterAttendance${searchParams}`,
  UPDATE_ATTENDANCE_BY_ADMIN: `${featuresUrl}/Attendance/updateAttendanceByAdmin`,
  DELETE_ATTENDANCE: `${featuresUrl}/Attendance/deleteAttendance`,
  DELETE_MANY_ATTENDANCE: `${featuresUrl}/Attendance/deleteManyAttendance`,
  GET_ATTENDANCE: `${featuresUrl}/Attendance/getAttendance`,
  GET_ATTENDANCE_OF_EMPLOYEE: `${featuresUrl}/Attendance/getAttendanceByEmployee`,
  GET_ATTENDANCE_BY_POSITION: `${featuresUrl}/Attendance/filterAttendance`,
  GET_ATTENDANCE_SUMMARY: (searchParams) => `${featuresUrl}/Attendance/getAttendanceReport${searchParams}`,
  GET_ATTENDANCE_IN_TIME_REPORT: (searchParams) => `${featuresUrl}/Attendance/getAttendanceInTimeReport${searchParams}`,
  GET_CHECKIN_CHECKOUT_REPORT: (searchParams) => `${backendUrl}/visit/getCheckInCheckOutReport${searchParams}`,
  GET_ATTENDANCE_MONTHLY_LATE_REPORT: (searchParams) => `${featuresUrl}/Attendance/getAttendanceMonthlyLateReport${searchParams}`,
  GET_PRODUCTIVE_TIME_REPORT: (searchParams) => `${featuresUrl}/Attendance/getProductiveTimeReport${searchParams}`,
  GET_TEAM_LEASE_DUMP_REPORT: (searchParams) => `${featuresUrl}/Attendance/getTeamLeaseDumpReport${searchParams}`,

  GET_ADDRESS_BY_COORDINATES: (lat, long) => `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${GOOGLE_API}`,

  //PRODUCTS....
  GET_ALL_PRODUCTS: (filterParam) => `${featuresUrl}/Product/getAllProduct${filterParam}`,
  ADD_PRODUCT: `${featuresUrl}/Product/addProduct`,
  EDIT_PRODUCT: `${featuresUrl}/Product/editProduct`,
  DELETE_PRODUCT: `${featuresUrl}/Product/deleteProduct`,
  DELETE_MANY_PRODUCT: `${featuresUrl}/Product/deleteManyProduct`,
  GET_PRODUCT: `${featuresUrl}/Product/getProduct`,
  GET_ALL_SECONDARY_VARIANT: (searchParams) => `${featuresUrl}/Product/getAllSecondaryVariant${searchParams}`,

  //CUSTOMERS....
  GET_ALL_CUSTOMERS: (searchParams) => `${featuresUrl}/Customer/getAllCustomer${searchParams}`,
  ADD_CUSTOMER: `${featuresUrl}/Customer/addCustomer`,
  EDIT_CUSTOMER: `${featuresUrl}/Customer/editCustomer`,
  DELETE_CUSTOMER: `${featuresUrl}/Customer/deleteCustomer`,
  DELETE_MANY_CUSTOMER: `${featuresUrl}/Customer/deleteManyCustomer`,
  GET_CUSTOMER: `${featuresUrl}/Customer/getCustomer`,

  //CATEGORY
  GET_ALL_CATEGORIES: (searchParams) => `${featuresUrl}/Category/getAllCategory${searchParams}`,
  ADD_CATEGORY: `${featuresUrl}/Category/addCategory`,
  EDIT_CATEGORY: `${featuresUrl}/Category/editCategory`,
  DELETE_CATEGORY: `${featuresUrl}/Category/deleteCategory`,
  DELETE_MANY_CATEGORY: `${featuresUrl}/Category/deleteManyCategory`,
  GET_CATEGORY: `${featuresUrl}/Category/getCategory`,

  //SUB CATEGORY
  GET_ALL_SUBCATEGORIES: (searchParams) => `${featuresUrl}/SubCategory/getAllSubCategory${searchParams}`,
  GET_SUBCATEGORY: `${featuresUrl}/SubCategory/getSubCategory`,
  GET_ALL_SUBCATEGORIES_BY_CATEGORY: `${featuresUrl}/SubCategory/getAllSubCategoryByCategory`,
  ADD_SUBCATEGORY: `${featuresUrl}/SubCategory/addSubCategory`,
  EDIT_SUBCATEGORY: `${featuresUrl}/SubCategory/editSubCategory`,
  DELETE_SUBCATEGORY: `${featuresUrl}/SubCategory/deleteSubCategory`,
  DELETE_MANY_SUBCATEGORY: `${featuresUrl}/SubCategory/deleteManySubCategory`,

  //EMPLOYEE
  ADD_EMPLOYEE: `${backendUrl}/detail/addEmployee`,
  GET_ALL_EMPLOYEE: (searchParams) => `${backendUrl}/detail/getBelowEmployee${searchParams}`,
  GET_ALL_EMPLOYEE_BY_POSITION: `${backendUrl}/detail/getEmployeeDetailByPosition`,
  GET_ALL_EMPLOYEE_BY_RANK: `${backendUrl}/detail/getEmployeeByRank`,
  GET_EMPLOYEE: `${backendUrl}/detail/getEmployeeDetailsById`,
  EDIT_EMPLOYEE: `${backendUrl}/detail/editEmployee`,
  DELETE_EMPLOYEE: `${backendUrl}/detail/deleteEmployee`,
  DELETE_MANY_EMPLOYEE: `${backendUrl}/detail/deleteManyEmployee`,

  //LEAD
  GET_ALL_LEADS: (searchParams) => `${featuresUrl}/Lead/getAllLead${searchParams}`,
  DELETE_LEAD: `${featuresUrl}/Lead/deleteLead`,
  GET_LEAD: `${featuresUrl}/Lead/getLead`,
  SEND_QUOTE: `${featuresUrl}/Lead/sendQuote`,
  EDIT_LEAD: `${featuresUrl}/Lead/editLead`,
  ADD_LEAD: `${featuresUrl}/Lead/addLead`,
  DELETE_MANY_LEAD: `${featuresUrl}/Lead/deleteManyLead`,
  GET_LEAD_GENERATION_SUMMARY_REPORT: (searchParams) => `${featuresUrl}/Lead/getLeadGenerationSummaryReport${searchParams}`,

  GET_LEAD_STATUS_REPORT: (searchParams) => `${featuresUrl}/Lead/getLeadStatusReport${searchParams}`,

  GET_PRODUCT_CATEGORY_LEAD_REPORT: (searchParams) => `${featuresUrl}/Lead/getProductCategoryLeadReport${searchParams}`,

  GET_PRODUCT_CATEGORY_DETAILED_REPORT_MTD: (searchParams) => `${featuresUrl}/Lead/getProductCategoryDetailedReportMTD${searchParams}`,

  GET_PROMOTERWISE_DETAILED_REPORT_MTD: (searchParams) => `${featuresUrl}/Lead/getPromoterWiseDetailedReportMTD${searchParams}`,

  GET_LEAD_AGING_REPORT: (searchParams) => `${featuresUrl}/Lead/getLeadAgingReport${searchParams}`,

  GET_TSM_DETAILED_REPORT_MTD: (searchParams) => `${featuresUrl}/Lead/getTSMDetailedReportMTD${searchParams}`,
  GET_LEAD_DUMP_REPORT: (searchParams) => `${featuresUrl}/Lead/getLeadDumpReport${searchParams}`,
  ADD_ORDERS: `${featuresUrl}/Order/addOrders`,

  // REGION
  GET_ALL_REGION: `${locationUrl}/Region/getAllRegion`,
  GET_ALL_REGION_BY_COMPANY: (searchParams) => `${locationUrl}/Region/getAllRegionByCompany${searchParams}`,
  GET_REGION: (regionId) => `${locationUrl}/Region/getRegion${regionId}`,
  ADD_REGION: `${locationUrl}/Region/addRegion`,
  EDIT_REGION: `${locationUrl}/Region/editRegion`,
  DELETE_REGION: `${locationUrl}/Region/deleteRegion`,
  DELETE_MANY_REGION: `${locationUrl}/Region/deleteManyRegion`,

  // ZONE
  GET_ALL_ZONE :`${locationUrl}/Zone/getAllZone`,
  GET_ALL_ZONE_BY_COMPANY: (searchParams) => `${locationUrl}/Zone/getAllZoneByCompany${searchParams}`,
  GET_ZONE: (zoneId) => `${locationUrl}/Zone${zoneId}`,
  ADD_ZONE: `${locationUrl}/Zone/addZone`,
  EDIT_ZONE: `${locationUrl}/Zone/editZone`,
  DELETE_ZONE: `${locationUrl}/Zone/deleteZone`,
  DELETE_MANY_ZONE: `${locationUrl}/Zone/deleteManyZone`,

  // STATE
  GET_ALL_STATE: `${locationUrl}/State/getAllState`,
  GET_ALL_STATE_BY_COMPANY: (searchParams) => `${locationUrl}/State/getAllStateByCompany${searchParams}`,
  GET_STATE: (stateId) => `${locationUrl}/State/getState?stateId=${stateId}`,
  ADD_STATE: `${locationUrl}/State/addState`,
  EDIT_STATE: `${locationUrl}/State/editState`,
  DELETE_STATE: `${locationUrl}/State/deleteState`,
  DELETE_MANY_STATE: `${locationUrl}/State/deleteManyState`,

  // DISTRICT
  GET_ALL_DISTRICT: `${locationUrl}/District/getAllDistrict`,
  GET_ALL_DISTRICT_BY_COMPANY: (searchParams) => `${locationUrl}/District/getAllDistrictByCompany${searchParams}`,
  GET_DISTRICT: (districtId) => `${locationUrl}/District/getDistrict?districtId=${districtId}`,
  ADD_DISTRICT: `${locationUrl}/District/addDistrict`,
  EDIT_DISTRICT: `${locationUrl}/District/editDistrict`,
  DELETE_DISTRICT: `${locationUrl}/District/deleteDistrict`,
  DELETE_MANY_DISTRICT: `${locationUrl}/District/deleteManyDistrict`,

  // CITY
  GET_ALL_CITY: `${locationUrl}/City/getAllCity`,
  GET_ALL_CITY_BY_COMPANY: (searchParams) => `${locationUrl}/City/getAllCityByCompany${searchParams}`,
  GET_CITY: (cityId) => `${locationUrl}/City/getCity?cityId=${cityId}`,
  ADD_CITY: `${locationUrl}/City/addCity`,
  EDIT_CITY: `${locationUrl}/City/editCity`,
  DELETE_CITY: `${locationUrl}/City/deleteCity`,
  DELETE_MANY_CITY: `${locationUrl}/City/deleteManyCity`,

  // AREA
  GET_ALL_AREA: `${locationUrl}/Area/getAllArea`,
  GET_ALL_AREA_BY_COMPANY: (searchParams) => `${locationUrl}/Area/getAllAreaByCompany${searchParams}`,
  GET_AREA: (areaId) => `${locationUrl}/Area/getArea?areaId=${areaId}`,
  ADD_AREA: `${locationUrl}/Area/addArea`,
  EDIT_AREA: `${locationUrl}/Area/editArea`,
  DELETE_AREA: `${locationUrl}/Area/deleteArea`,
  DELETE_MANY_AREA: `${locationUrl}/Area/deleteManyArea`,

  // STORE
  GET_ALL_STORE: `${locationUrl}/Store/getAllStore`,
  GET_ALL_STORE_BY_COMPANY: (searchParams) => `${locationUrl}/Store/getAllStoreByCompany${searchParams}`,
  GET_STORE: (storeId) => `${locationUrl}/Store/getStore?storeId=${storeId}`,
  ADD_STORE: `${locationUrl}/Store/addStore`,
  EDIT_STORE: `${locationUrl}/Store/editStore`,
  DELETE_STORE: `${locationUrl}/Store/deleteStore`,
  DELETE_MANY_STORE: `${locationUrl}/Store/deleteManyStore`,

  //BULK UPLOAD
  BULK_UPLOAD: `${backendUrl}/Features/BulkUpload/upload`,
  BULK_UPLOAD_SUBCATEGORY: `${backendUrl}/Features/BulkUpload/uploadSubCategory`,
  BULK_UPLOAD_PRODUCT: `${backendUrl}/Features/BulkUpload/uploadProduct`,
  BULK_UPLOAD_TMPORDER: `${tmpOrderUrl}/BulkUpload/uploadTmpOrder`,
  BULK_UPLOAD_BEAT: `${backendUrl}/Features/BulkUpload/uploadBeatPlan`,

  // COMPANYC ADMIN....
  UPDATE_COMPANY_ADMIN: `${backendUrl}/CompanyAdmin/updateCompanyAdmin`,
  UPDATE_COMPANY_ADMIN_PERSONAL_INFO: `${backendUrl}/CompanyAdmin/updateCompanyAdminPersonalInfo`,
  UPDATE_COMPANY_ADMIN_SETTING: `${backendUrl}/CompanyAdmin/updateCompanyAdminSetting`,
  GET_COMPANY_ADMIN: `${backendUrl}/CompanyAdmin/getCompanyAdmin`,

  // PRODUCT CATALOGUE
  ADD_PRODUCTCATALOGUE: `${backendUrl}/Features/ProductCatalouge/addProductCatalogue`,
  GET_ALL_PRODUCTCATALOGUE: (params) => `${backendUrl}/Features/ProductCatalouge/getAllProductCatalogue${params}`,
  GET_PRODUCTCATALOGUE: `${backendUrl}/Features/ProductCatalouge/getProductCatalogue`,
  UPDATE_PRODUCTCATALOGUE: `${backendUrl}/Features/ProductCatalouge/editProductCatalogue`,
  DELETE_PRODUCTCATALOGUE: `${backendUrl}/Features/ProductCatalouge/deleteProductCatalogue`,
  DELETE_MANY_PRODUCTCATALOUGE: `${backendUrl}/Features/ProductCatalouge/deleteManyProductCatalogue`,

  // CHANNEL TYPE
  GET_ALL_CHANNEL_TYPE: `${targetUrl}/getChannelTypeByRank`,


  // MASTER CHANNEL TYPES
  GET_CHANNEL_TYPE_MASTER: `${backendUrl}/channel/types`,
  GET_CHANNEL_TYPES:  (searchParams) => `${backendUrl}/channel/types${searchParams}`,

  // TARGET TYPE
  GET_ALL_TARGET_TYPE: `${targetUrl}/getAllTargetType`,

  // TEMPLATE CATEGORY
  GET_ALL_TEMPLATE_CATEGORY: `${targetUrl}/getAllTemplateCategory`,

  // TARGET
  GET_ALL_TARGET: (searchParams) => `${targetUrl}/getAllTarget${searchParams}`,
  GET_TARGET: `${targetUrl}/getTarget`,
  ADD_TARGET: `${targetUrl}/addTarget`,
  EDIT_TARGET: `${targetUrl}/editTarget`,
  DELETE_TARGET: `${targetUrl}/deleteTarget`,
  DELETE_MANY_TARGET: `${targetUrl}/deleteManyTarget`,

  // POSITION
  GET_ALL_POSITIONS: `${featuresUrl}/Position/getAllPosition`,
  GET_ALL_POSITIONS_BY_COMPANY: (searchParams) => `${featuresUrl}/Position/getAllPositionByCompany${searchParams}`,
  LINK_POSITION: `${featuresUrl}/Position/linkPosition`,
  GET_POSITION: (positionId) => `${featuresUrl}/Position/getPosition?positionId=${positionId}`,
  ADD_POSITION: `${featuresUrl}/Position/addPosition`,
  EDIT_POSITION: `${featuresUrl}/Position/editPosition`,
  DELETE_POSITION: `${featuresUrl}/Position/deletePosition`,
  DELETE_MANY_POSITION: `${featuresUrl}/Position/deleteManyPosition`,

  // LEAD TYPE
  GET_ALL_LEADTYPE: (searchParams) => `${featuresUrl}/LeadType/getAllLeadType${searchParams}`,
  GET_LEADTYPE: (leadTypeId) => `${featuresUrl}/LeadType/getLeadType?leadTypeId=${leadTypeId}`,
  ADD_LEADTYPE: `${featuresUrl}/LeadType/addLeadType`,
  EDIT_LEADTYPE: `${featuresUrl}/LeadType/editLeadType`,
  DELETE_LEADTYPE: `${featuresUrl}/LeadType/deleteLeadType`,
  DELETE_MANY_LEADTYPE: `${featuresUrl}/LeadType/deleteManyLeadType`,

  // LEAVE TYPE
  GET_ALL_LEAVETYPE: (searchParams) => `${featuresUrl}/LeaveType/getAllLeaveType${searchParams}`,
  GET_LEAVETYPE: (leaveTypeId) => `${featuresUrl}/LeaveType/getLeaveType?leaveTypeId=${leaveTypeId}`,
  ADD_LEAVETYPE: `${featuresUrl}/LeaveType/addLeaveType`,
  EDIT_LEAVETYPE: `${featuresUrl}/LeaveType/editLeaveType`,
  DELETE_LEAVETYPE: `${featuresUrl}/LeaveType/deleteLeaveType`,
  DELETE_MANY_LEAVETYPE: `${featuresUrl}/LeaveType/deleteManyLeaveType`,

  // TOTAL LEAVE
  GET_ALL_TOTAL_LEAVE: (searchParams) => `${featuresUrl}/totalLeave/getAllTotalLeave${searchParams}`,
  // GET_ALL_TOTAL_LEAVE_BY_COMPANY: `${featuresUrl}/TotalLeave/getAllTotalLeaveByCompany`,
  GET_TOTAL_LEAVE: (totalLeaveId) => `${featuresUrl}/totalLeave/getTotalLeave?totalLeaveId=${totalLeaveId}`,
  ADD_TOTAL_LEAVE: `${featuresUrl}/totalLeave/addTotalLeave`,
  EDIT_TOTAL_LEAVE: `${featuresUrl}/totalLeave/editTotalLeave`,
  DELETE_TOTAL_LEAVE: `${featuresUrl}/totalLeave/deleteTotalLeave`,
  DELETE_MANY_TOTAL_LEAVE: `${featuresUrl}/totalLeave/deleteManyTotalLeave`,

  // TAX
  GET_ALL_TAX: (searchParams) => `${masterUrl}/Tax/getAllTax${searchParams}`,
  GET_TAX: (taxId) => `${masterUrl}/Tax/getTax?taxId=${taxId}`,
  ADD_TAX: `${masterUrl}/Tax/addTax`,
  EDIT_TAX: `${masterUrl}/Tax/editTax`,
  DELETE_TAX: (taxId) => `${masterUrl}/Tax/deleteTax?taxId=${taxId}`,
  DELETE_MANY_TAX: `${masterUrl}/Tax/deleteManyTax`,

  // SCHEME
  GET_ALL_SCHEME: (searchParams) => `${masterUrl}/Scheme/getAllScheme${searchParams}`,
  GET_SCHEME: (schemeId) => `${masterUrl}/Scheme/getScheme?schemeId=${schemeId}`,
  ADD_SCHEME: `${masterUrl}/Scheme/addScheme`,
  EDIT_SCHEME: `${masterUrl}/Scheme/editScheme`,
  DELETE_SCHEME: (schemeId) => `${masterUrl}/Scheme/deleteScheme?schemeId=${schemeId}`,
  DELETE_MANY_SCHEME: `${masterUrl}/Scheme/deleteManyScheme`,


  // HOLIDAYS
  GET_ALL_HOLIDAYS: (searchParams) =>  `${masterUrl}/Holiday/getALlHolidays${searchParams}`, 
  EDIT_HOLIDAY:  `${masterUrl}/Holiday/editHoliday`,
  DELETE_HOLIDAYS: (searchParams)=> `${masterUrl}/Holiday/deleteMany/${searchParams}`,
  ADD_HOLIDAY: `${masterUrl}/Holiday/addHoliday/`,

  // LEADSOURCE
  GET_ALL_LEADSOURCE: (searchParams) => `${masterUrl}/LeadSource/getAllLeadSource${searchParams}`,
  GET_LEADSOURCE: (leadSourceId) => `${masterUrl}/LeadSource/getLeadSource?leadSourceId=${leadSourceId}`,
  ADD_LEADSOURCE: `${masterUrl}/LeadSource/addLeadSource`,
  EDIT_LEADSOURCE: `${masterUrl}/LeadSource/editLeadSource`,
  DELETE_LEADSOURCE: (leadSourceId) => `${masterUrl}/LeadSource/deleteLeadSource?leadSourceId=${leadSourceId}`,
  DELETE_MANY_LEADSOURCE: `${masterUrl}/LeadSource/deleteManyLeadSource`,

  // CUSTOMERTYPE
  GET_ALL_CUSTOMERTYPE: (searchParams) => `${masterUrl}/CustomerType/getAllCustomerType${searchParams}`,
  GET_CUSTOMERTYPE: (customerTypeId) => `${masterUrl}/CustomerType/getCustomerType?customerTypeId=${customerTypeId}`,
  ADD_CUSTOMERTYPE: `${masterUrl}/CustomerType/addCustomerType`,
  EDIT_CUSTOMERTYPE: `${masterUrl}/CustomerType/editCustomerType`,
  DELETE_CUSTOMERTYPE: (customerTypeId) => `${masterUrl}/CustomerType/deleteCustomerType?customerTypeId=${customerTypeId}`,
  DELETE_MANY_CUSTOMERTYPE: `${masterUrl}/CustomerType/deleteManyCustomerType`,

  // SALES_CHANNEL_TYPE
  GET_ALL_SALES_CHANNEL_TYPE: (searchParams) => `${masterUrl}/SalesChannelType/getAllSalesChannelType${searchParams}`,
  GET_SALES_CHANNEL_TYPE: (salesChannelTypeId) => `${masterUrl}/SalesChannelType/getSalesChannelType?salesChannelTypeId=${salesChannelTypeId}`,
  ADD_SALES_CHANNEL_TYPE: `${masterUrl}/SalesChannelType/addSalesChannelType`,
  EDIT_SALES_CHANNEL_TYPE: `${masterUrl}/SalesChannelType/editSalesChannelType`,
  DELETE_SALES_CHANNEL_TYPE: (salesChannelTypeId) => `${masterUrl}/SalesChannelType/deleteSalesChannelType?salesChannelTypeId=${salesChannelTypeId}`,
  DELETE_MANY_SALES_CHANNEL_TYPE: `${masterUrl}/SalesChannelType/deleteManySalesChannelType`,

  // SALES
  GET_ALL_PRIMARY_SALES: (searchParams) => `${backendUrl}/Sales/PrimarySales/getAllSales${searchParams}`,
  GET_PRIMARY_SALES: (primarySalesId) => `${backendUrl}/Sales/PrimarySales/getSales?primarySalesId=${primarySalesId}`,
  ADD_PRIMARY_SALES: `${backendUrl}/Sales/PrimarySales/addSales`,
  EDIT_PRIMARY_SALES: `${backendUrl}/Sales/PrimarySales/editSales`,
  DELETE_PRIMARY_SALES: (primarySalesId) => `${backendUrl}/Sales/PrimarySales/deleteSales?primarySalesId=${primarySalesId}`,
  DELETE_MANY_PRIMARY_SALES: `${backendUrl}/Sales/PrimarySales/deleteManySales`,

  // SALES_RETURN
  GET_ALL_SALES_RETURN: `${backendUrl}/Sales/SalesReturn/getAllSalesReturn`,
  GET_SALES_RETURN: (salesReturnId) => `${backendUrl}/Sales/SalesReturn/getSalesReturn?salesReturnId=${salesReturnId}`,
  ADD_SALES_RETURN: `${backendUrl}/Sales/SalesReturn/addSalesReturn`,
  EDIT_SALES_RETURN: `${backendUrl}/Sales/SalesReturn/editSalesReturn`,
  DELETE_SALES_RETURN: (salesReturnId) => `${backendUrl}/Sales/SalesReturn/deleteSalesReturn?salesReturnId=${salesReturnId}`,
  DELETE_MANY_SALES_RETURN: `${backendUrl}/Sales/SalesReturn/deleteManySalesReturn`,

  // Lead Type Conversion
  GET_ALL_LEADTYPE_CONVERSION: (searchParams) => `${masterUrl}/LeadTypeConversion/getAllConvertLeadType${searchParams}`,
  GET_LEADTYPE_CONVERSION: (convertLeadTypeId) => `${masterUrl}/LeadTypeConversion/getConvertLeadType?convertLeadTypeId=${convertLeadTypeId}`,
  ADD_LEADTYPE_CONVERSION: `${masterUrl}/LeadTypeConversion/addConvertLeadType`,
  EDIT_LEADTYPE_CONVERSION: `${masterUrl}/LeadTypeConversion/editConvertLeadType`,
  DELETE_LEADTYPE_CONVERSION: (convertLeadTypeId) => `${masterUrl}/LeadTypeConversion/deleteConvertLeadType?convertLeadTypeId=${convertLeadTypeId}`,
  DELETE_MANY_LEADTYPE_CONVERSION: `${masterUrl}/LeadTypeConversion/deleteManyConvertLeadType`,

  // INCENTIVE
  GET_ALL_INCENTIVES: (searchParams) => `${backendUrl}/Sales/Incentive/getAllIncentive${searchParams}`,
  GET_ACHIEVEMENT_REPORT: (searchParams) => `${backendUrl}/Sales/Incentive/getAchievementReport${searchParams}`,
  GET_ACHIEVEMENT_REPORT_ONLY: (searchParams) => `${backendUrl}/Sales/Incentive/getAchievementReportApp${searchParams}`,
  GET_QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT: (searchParams) => `${backendUrl}/Sales/Incentive/getQuaterlyVsActualAchievementReport${searchParams}`,
  GET_QUATERLY_EARNING_REPORT: (searchParams) => `${backendUrl}/Sales/Incentive/getQuaterlyEarningReport${searchParams}`,
  GET_INCENTIVE_REPORT: (searchParams) => `${backendUrl}/Sales/Incentive/getIncentiveReport${searchParams}`,

  // PERMISSIoN
  ADD_PERMISSION: `${backendUrl}/Authorization/Permission/addPermission`,
  EDIT_PERMISSION:  (params)=>`${backendUrl}/Authorization/Permission/editPermission/${params}`,
  GET_ALL_PERMISSIONS: (searchParams) => `${backendUrl}/Authorization/Permission/getAllPermissions/${searchParams}`,
  GET_PERMISSION: (permissionId) => `${backendUrl}/Authorization/Permission/getPermission/${permissionId}`,
  DELETE_MANY_PERMISSION: (permissionId) => `${backendUrl}/Authorization/Permission/deletePermission/${permissionId}`,

  // MODULE ADMIN
  ADD_MODULEADMIN: `${backendUrl}/ModuleAdmin/addModuleAdmin`,
  EDIT_MODULEADMIN: `${backendUrl}/ModuleAdmin/editModuleAdmin`,
  GET_ALL_MODULEADMINS: (searchParams) => `${backendUrl}/ModuleAdmin/getAllModuleAdmins/${searchParams}`,
  GET_MODULEADMIN: (moduleAdminId) => `${backendUrl}/ModuleAdmin/getModuleAdmin/${moduleAdminId}`,
  DELETE_MODULEADMIN: `${backendUrl}/ModuleAdmin/deleteModuleAdmin`,
  // UPLOAD DATA
  GET_ALL_UPLOAD_DATA: (searchParams) => `${backendUrl}/UploadedData/getAllUploadedData/${searchParams}`,

  // REPORTS PHASE2

  GET_OPEN_TASK_REPORT: (searchParams) => `${auditUrl}/getOpenTaskReport${searchParams}`,
  GET_AUDIT_REPORT: (searchParams) => `${auditUrl}/getAuditReport${searchParams}`,

  GET_ARCHIEVED_REPORT: (searchParams) => `${learningUrl}/archievedReport${searchParams}`,
  GET_INDUCTION_REPORT: (searchParams) => `${learningUrl}/getInductionReport${searchParams}`,
  GET_CONTENT_REPORT: (searchParams) => `${learningUrl}/getContentReport${searchParams}`,
  GET_ACTIVE_CONTENT_REPORT: (searchParams) => `${learningUrl}/activeContentReport${searchParams}`,
  GET_LEARNING_SCORE_CARD: (searchParams) => `${learningUrl}/getLearningScoreCard${searchParams}`,
  GET_QUIZ_REPORT: (searchParams) => `${learningUrl}/getQuizReport/${searchParams}`,
  GET_LEADER_BOARD_REPORT: (searchParams) => `${backendUrl}/Reward/getLeaderBoardReport${searchParams}`,
  GET_TOP_KBC_REPORT: (searchParams) => `${backendUrl}/Reward/getTopKbcReport${searchParams}`,



   // TMP ORDER ROUTES
   GET_ALL_TMP_ORDERS: (searchParams) => `${tmpOrderUrl}/getAll/${searchParams}`, 
  //  GET_ALL_TMP_ORDERS:  `${tmpOrderUrl}/getAll`, 
   ADD_TMP_ORDER:  `${tmpOrderUrl}/add`,
   GET_TMP_ORDER: (searchParams) => `${tmpOrderUrl}/get/${searchParams}`,
   EDIT_TMP_ORDER: (searchParams) => `${tmpOrderUrl}/${searchParams}`,
   DELETE_ALL_TMP_ORDERS:  `${tmpOrderUrl}/`,
   DELETE_TMP_ORDERS: `${tmpOrderUrl}/multiple/`,


   // BEAT PLAN ROUTES
   GET_ALL_BEAT_PLANS: (searchParams) =>  `${backendUrl}/beat/plans/${searchParams}`, 
  //  GET_ALL_TMP_ORDERS:  `${tmpOrderUrl}/getAll`, 
   ADD_BEAT_PLAN:  `${backendUrl}/create/beat/plan`,
   EDIT_BEAT_PLAN: (searchParams) => `${backendUrl}/beat/plan/${searchParams}/update`,
  //  DELETE_BEAT_PLAN: (searchParams) => `${backendUrl}/beat/plan/${searchParams}/delete`,
   DELETE_BEAT_PLANS: `${backendUrl}/delete/beat/plans`,
   CHANNEL_TYPES: (searchParams) =>  `${backendUrl}/channel/types/${searchParams}`, 

   ADD_COMPANY_PERMISSIONS: `${backendUrl}/permissions`,
   GET_COMPANY_PERMISSIONS: `${backendUrl}/permissions`,
   EDIT_COMPANY_PERMISSIONS: (id)=>`${backendUrl}/permissions/${id}`,
   GET_COMPANY_PERMISSION: (id)=>`${backendUrl}/permissions/${id}`,


   TRAVEL_CATEGORY: (searchParams)=>`${backendUrl}/travel/category/${searchParams}`,

   // allowance types
   ALLOWANCE_TYPES: (searchParams)=> `${backendUrl}/allowance/types/${searchParams}`,

   // allowance/travel requests/travel-requests
    ALLOWANCE_REQUESTS: `${backendUrl}/create/allowance/requests`,
    ALLOWANCE_REQUESTS_SUPERVISOR:(searchParams)=>  `${backendUrl}/allowance/supervisor/requests/${searchParams}`,
    ADD_ALLOWANCE_REQUEST: `${backendUrl}/allowance/requests`,
    EDIT_ALLOWANCE_REQUEST: `${backendUrl}/update/allowance/requests`,

    // add deaed
    ADD_DEALER:(level, searchParams)=>  `${backendUrl}/dealer/level/${level}/${searchParams}`,
    GET_DEALER:(id)=>  `${backendUrl}/dealer/${id}`,


}
